


















import { Vue, Component, Model, Emit } from "vue-property-decorator";

@Component
export default class StepPicker extends Vue {
  @Model("input", { type: String, required: true })
  step!: string;

  @Emit("input")
  emitInput(value: string) {
    return value;
  }
}
